import { NgModule } from '@angular/core';

import { TermsDialogComponent } from './terms-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@ridango/core';
import { DialogLayoutModule } from '../dialog-layout';

@NgModule({
    imports: [TranslateModule, CommonModule, DialogLayoutModule, CoreModule],
    exports: [TermsDialogComponent],
    declarations: [TermsDialogComponent],
    providers: [],
})
export class TermsDialogModule {}
